
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingDetailsGrid extends Serenity.EntityGrid<SKUSplittingDetailsRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUSplittingDetails'; }
        protected getDialogType() { return SKUSplittingDetailsDialog; }
        protected getIdProperty() { return SKUSplittingDetailsRow.idProperty; }
        protected getInsertPermission() { return SKUSplittingDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUSplittingDetailsRow.localTextPrefix; }
        protected getService() { return SKUSplittingDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}